import api from '../../services/api';
import { toast } from 'react-toastify';
import i18n from '../../utils/i18n.ts';

export const fetchOrganizationUnitLists = async () => {
  const response = await api.get(`/organizationUnitLists?showInactive=false`);

  if (!response) {
    toast.error(i18n.t('error.api.get-list', { item: i18n.t('module.organization-unit-lists') }));
  }

  return response.data;
};

export const fetchOrganizationUnitListById = async (id: number | string | undefined | null) => {
  const response = await api.get(`/organizationUnitLists/${id}`);
  if (!response) {
    toast.error(i18n.t('error.api.get-item', { item: i18n.t('module.organization-unit-list') }));
  }
  return response.data;
};

export const createOrganizationUnitList = async (data: unknown) => {
  const response = await api.post(`/organizationUnitLists`, data);
  if (!response) {
    toast.error(i18n.t('error.api.post-item', { item: i18n.t('module.organization-unit-list') }));
  }
  return response.data;
};

export const updateOrganizationUnitList = async ({ data }: { data: unknown }) => {
  const response = await api.put(`/organizationUnitLists`, data);

  if (!response) {
    toast.error(i18n.t('error.api.put-item', { item: i18n.t('module.organization-unit-list') }));
  }

  return true;
};

export const deleteOrganizationUnitList = async (params: { ids: number[] }) => {
  const response = await api.delete(`/organizationUnitLists`, { data: params });
  if (!response) {
    toast.error(i18n.t('error.api.delete-item', { item: i18n.t('module.organization-unit-list') }));
  }
  return true;
};

export const searchLeadership = async (term: string) => {
  if (!term) return [];

  const res = await api.get(`/entra/search?searchText=${encodeURIComponent(term)}&type=1`);
  if (!res) {
    toast.error(i18n.t('error.api.network-error'));
  }
  return res.data;
};
